import { Component, Input } from '@angular/core';
import { faHome } from '@fortawesome/pro-duotone-svg-icons';
import { HOME_BOXES } from '../../constants/general.constants';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-side-bar',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, RouterModule],
  templateUrl: './side-bar.component.html',
  styleUrl: './side-bar.component.scss'
})
export class SideBarComponent {
  @Input() isMenuOpen: boolean = false;

  itemsMenu: any = [];

  constructor() {
    this.itemsMenu = [
      {
      section: '',
      boxes: [{
        name: 'Inicio',
        icon: faHome,
        routerLink: '/home', 
        swapOpacity: false,
      }]
      }].concat(HOME_BOXES);
  }
  ngOnInit() {
  }

  isActiveLink(item: any) {
    return window.location.pathname.includes(item.routerLink);
  }
}
